<template>
  <v-form>
    <v-progress-linear
      v-if="loading"
      indeterminate
      color="blue"
    ></v-progress-linear>
    <div class="pa-10">
      <v-container>
        <v-layout row v-if="errors">
          <v-flex>
            <Alert @dismissed="onDismissed" :text="errors"></Alert>
          </v-flex>
        </v-layout>
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="4">
            <v-autocomplete
              v-model="form.input_type"
              :items="input_types"
              label="Input Type*"
              dense
              outlined
              @change="typeChange()"
              clearable
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="4">
            <v-text-field
              outlined
              dense
              v-model="form.key"
              required
              label="Key*"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="4">
            <v-text-field
              outlined
              dense
              v-model="form.label"
              required
              label="Label*"
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-row>
              <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
                <v-textarea
                  rows="4"
                  outlined
                  dense
                  v-model="form.validations"
                  label="Validations"
                >
                </v-textarea>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
                <v-textarea
                  v-if="
                    form.input_type == 'Dropdown' ||
                      form.input_type == 'Multi_Dropdown'
                  "
                  rows="4"
                  outlined
                  dense
                  v-model="form.dropdown_values"
                  label="Dropdown Values (Comma Separate)"
                >
                </v-textarea>
              </v-col>
            </v-row>
          </v-col>
          <v-col>
            <v-row>
              <v-col cols="12" xs="12" sm="6" md="6" lg="4" xl="2">
                <v-switch
                  v-model="is_required"
                  label="Is Required"
                  :false-value="0"
                  :true-value="1"
                  color="info"
                  hide-details
                ></v-switch>
              </v-col>
              <v-col cols="12" xs="12" sm="6" md="6" lg="4" xl="2">
                <v-switch
                  v-model="show_list_page"
                  label="Show list page"
                  :false-value="0"
                  :true-value="1"
                  color="info"
                  hide-details
                ></v-switch>
              </v-col>
              <v-col cols="12" xs="12" sm="6" md="6" lg="4" xl="2">
                <v-switch
                  v-model="can_search"
                  label="Can search"
                  :false-value="0"
                  :true-value="1"
                  color="info"
                  hide-details
                ></v-switch>
              </v-col>
              <v-col cols="12" xs="12" sm="6" md="6" lg="4" xl="2">
                <v-switch
                  v-model="show_project_report"
                  label="Show project report"
                  :false-value="0"
                  :true-value="1"
                  color="info"
                  hide-details
                ></v-switch>
              </v-col>
              <v-col cols="12" xs="12" sm="6" md="6" lg="4" xl="2">
                <v-switch
                  v-model="enable"
                  label="Enable"
                  :false-value="0"
                  :true-value="1"
                  color="info"
                  hide-details
                ></v-switch>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions>
        <v-row>
          <v-col cols="12" md="9" xs="6"></v-col>
          <v-col cols="12" md="3" xs="6">
            <v-btn
              large
              color="#00B3FF"
              dark
              depressed
              :loading="loading"
              block
              @click="create()"
              >Add</v-btn
            >
          </v-col>
        </v-row>
      </v-card-actions>
    </div>
    <Snackbars
      :text="successMsg"
      :snackbar="snackbar"
      :color="'success'"
      @classSnackbar="closeSnackbar"
    />
    <Snackbars
      :text="'Validation error please scroll up'"
      :snackbar="snackbarError"
      :color="'red'"
      @classSnackbar="closeSnackbar"
    />
  </v-form>
</template>

<script>
import Alert from "@/components/shared/Alert";
import { ProjectService } from "@/services/project-service.js";
import { checkError } from "@/config/errors.js";
import Snackbars from "@/components/shared/Snackbars";

export default {
  name: "DynamicFields",
  components: { Alert, Snackbars },
  props: ["name"],
  data: () => ({
    form: {
      input_type: "",
      key: "",
      label: "",
      validations: "",
      dropdown_values: "",
    },
    is_required: 0,
    show_list_page: 0,
    can_search: 0,
    show_project_report: 0,
    enable: 0,
    snackbar: false,
    employer_data: "",
    snackbarError: false,
    successMsg: "Project field has been created successfully",
    errors: null,
    loading: false,
    input_types: [
      "Input",
      "Text_Area",
      "Dropdown",
      "Multi_Dropdown",
      "Date_Picker",
    ],
  }),


  methods: {
    create() {
      this.errors = null;
      let fd = new FormData();

      fd.append("input_type", this.form.input_type);
      fd.append("key", this.form.key);
      fd.append("label", this.form.label);
      fd.append("validations", this.validations || "");
      fd.append("dropdown_values", this.form.dropdown_values || "");
      fd.append("is_required", this.is_required);
      fd.append("show_list_page", this.show_list_page);
      fd.append("can_search", this.can_search);
      fd.append("show_project_report", this.show_project_report);
      fd.append("enable", this.enable);

      this.loading = true;
      ProjectService.addDynamicProjectFields(fd)
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.reset();
            this.snackbar = true;
            this.snackbarError = false;
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },
    closeSnackbar() {
      this.snackbar = false;
    },
    onDismissed() {
      this.errors = null;
    },
    reset() {
      this.form = [];
    },
  },
};
</script>
